import React from 'react';
import {Menu, MenuItem} from '@mui/material';

/**
 * Context menu for folder actions.
 */
const FolderMenu = ({anchorEl, onClose, onRename, onMove, onDelete}) => {
    const handleClick = (action) => (event) => {
        event?.stopPropagation?.();
        onClose(event);
        action();
    };

    return (
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
            <MenuItem onClick={handleClick(onRename)}>Rename Folder</MenuItem>
            <MenuItem onClick={handleClick(onMove)}>Move</MenuItem>
            <MenuItem onClick={handleClick(onDelete)}>Delete</MenuItem>
        </Menu>
    );
};

export default FolderMenu;
